import { useEffect, useContext } from 'react';
import CompanyReport from './index';
import { tfpDefaultMenuList, reportSectionMenus } from 'kosmos/TfpApp';
import MenuConfigContext from 'data/MenuConfigContext';
import { KosmosReportDto } from 'models/dtoTypes';
import { useTranslation } from 'react-i18next';

interface IProps {
  id: string;
  organisationId?: string;
  onFetchReport: (id: string) => Promise<KosmosReportDto[]>;
  onBack?: () => void;
}

export default function CompanyReportWithMenus(props: IProps): JSX.Element {
  const { id, organisationId, onBack, onFetchReport } = props;
  const context = useContext(MenuConfigContext);
  const { t } = useTranslation('default');

  useEffect(() => {
    const { setMenuItems } = context;
    setMenuItems && setMenuItems(reportSectionMenus(t));
    return () => {
      // unmount, clear menu
      setMenuItems && setMenuItems(tfpDefaultMenuList(t));
    };
  }, []);

  return (
    <CompanyReport
      id={id}
      organisationId={organisationId}
      onBack={onBack}
      onFetchReport={onFetchReport}
    />
  );
}
